import {useCookies} from '@optimaxdev/utils';

import {useSelector} from 'react-redux';

import {getExistedOrderBeforeToday} from 'desktop/pages/success/store/selectors/orderLast/orderLast';
import {useExperiment} from 'libs/experiment';

/**
 * Sites & Organizations
 * ID 5138974 only for glassesusa.com production
 * we have org. GlassesUSA.com with this ID, it should be stable and doesn't change during tests
 *
 * ID 5138979 for test purposes only DON'T FORGET TO MIRRORING all info from main to test one
 * we have org. GlassesUSA.com with this ID, we able to change it to one of test domain or staging
 * for example: "glassesusa.dev", "gusa-29256-gusa-desktop.gusadev.com/checkout/onepage/success"
 */
export const HOTJAR_SITE_ID = process.env.APP_ENV === 'production' ? 5138974 : 5138979;
export const HOTJAR_VERSION = 6;

/**
 * hook for Hotjar survey, checks flag condition and country of user
 * fires EXP indication
 * @returns {boolean} boolean state of flag and country condition
 */
export const useHotjarSurvey = () => {
    const isUserHaveOrderBefore = useSelector(getExistedOrderBeforeToday);
    const [cookies] = useCookies();

    const geolocation = (cookies['x-akamai-geo'] || '').split(',');
    // @ts-expect-error
    const [isHotjarExp] = useExperiment('dHotjarTYPv2', {
        extraConditions: [geolocation[1] === 'US'],
    });

    return Boolean(isHotjarExp && !isUserHaveOrderBefore);
};
